/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ENabavkiBodyRequest { 
    type?: ENabavkiBodyRequest.TypeEnum;
    grid?: boolean;
    body?: string;
    eMarket?: boolean;
}
export namespace ENabavkiBodyRequest {
    export type TypeEnum = 'CONTRACT_NOTICE' | 'E_MARKET' | 'CONCESSION' | 'DEFENSE_AND_SECURITY_LAW' | 'SPECIAL_SERVICES' | 'TECHNICAL_DIALOGUES' | 'CONTRACT_AWARD' | 'CANCELLATION' | 'MODIFICATION' | 'LATEST_DECISION';
    export const TypeEnum = {
        CONTRACTNOTICE: 'CONTRACT_NOTICE' as TypeEnum,
        EMARKET: 'E_MARKET' as TypeEnum,
        CONCESSION: 'CONCESSION' as TypeEnum,
        DEFENSEANDSECURITYLAW: 'DEFENSE_AND_SECURITY_LAW' as TypeEnum,
        SPECIALSERVICES: 'SPECIAL_SERVICES' as TypeEnum,
        TECHNICALDIALOGUES: 'TECHNICAL_DIALOGUES' as TypeEnum,
        CONTRACTAWARD: 'CONTRACT_AWARD' as TypeEnum,
        CANCELLATION: 'CANCELLATION' as TypeEnum,
        MODIFICATION: 'MODIFICATION' as TypeEnum,
        LATESTDECISION: 'LATEST_DECISION' as TypeEnum
    };
}